export default __webpack_public_path__ + "static/media/img-0757-slovenia-full-face.f1c4c242.png";